function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-13.698 -7.277)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M30.98,22.293a1.242,1.242,0,0,0-1.242,1.242V32.3H11.012V13.558h7.493a1.249,1.249,0,1,0,0-2.5H9.742A1.242,1.242,0,0,0,8.5,12.3V33.51a1.242,1.242,0,0,0,1.242,1.242H30.98a1.242,1.242,0,0,0,1.242-1.242V23.534A1.242,1.242,0,0,0,30.98,22.293Z",
  transform: "translate(5.198 1.743)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M34.766,12.9,29.479,7.647a1.242,1.242,0,0,0-1.767,0L15.485,19.916a1.242,1.242,0,0,0-.351.687l-.979,6.252a1.242,1.242,0,0,0,1.227,1.461h.19l6.281-.993a1.242,1.242,0,0,0,.687-.351L34.766,14.7a1.242,1.242,0,0,0,0-1.767ZM21.051,24.882l-4.192.672.643-4.163,7.669-7.7L28.675,17.2Zm9.421-9.451-3.506-3.506L28.544,10.3l3.52,3.491Z",
  transform: "translate(7.795 0)"
}));

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.232,
    height: 29.218,
    viewBox: "0 0 29.232 29.218",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.302f160d.svg";
export { ForwardRef as ReactComponent };